module.exports = __webpack_public_path__ + "img/kafeizong.4da974d2.png";